import React from "react";
import Grid from "@mui/material/Grid2";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { AboutUsLine } from "../../svgImage";
import styles from "./LandingPage.module.css";
import "react-multi-carousel/lib/styles.css";
import { ManualImageCarousel } from "../custom/Carousel";
import abstractPlate from "../../assets/gifting/abstractPlate.jpg";
import assortedChocolateBox from "../../assets/gifting/assortedChocolateBox.jpg";
import chocolateBox from "../../assets/gifting/chocolateBox.jpg";
import dryFruitBasket from "../../assets/gifting/dryFruitBasket.jpg";
import festiveBox from "../../assets/gifting/festiveBox.jpg";
const Gifting = () => {
  const isMobile = useMediaQuery("(max-width:468px)");
  const images = [
    {
      src: assortedChocolateBox,
      name: "Assorted Chocolate Box",
    },
    {
      src: abstractPlate,
      name: "Abstract Plate set",
    },

    {
      src: festiveBox,
      name: "Festive box",
    },
    {
      src: chocolateBox,
      name: "Chocolate box",
    },
    {
      src: dryFruitBasket,
      name: "Mediterranean Platter",
    },
  ];
  return (
    <Box
      maxWidth="940px"
      width="100%"
      margin="auto"
      display="flex"
      flexDirection={"column"}
      mt={"100px"}
      gap={{ xs: 4, md: 3 }}
      px={{ xs: 2, sm: 3, md: 0 }}
    >
      {/* LEFT SECTION */}
      <Box display={"flex"} flexDirection={"column"}>
        <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
          <AboutUsLine width={isMobile ? "60px" : "80px"} />
          <Typography
            className={styles.Aboutustext}
            paddingLeft={1}
            fontSize={{ xs: "18px", sm: "20px", md: "22px" }}
          >
            Gifting
          </Typography>
        </Box>

        <Typography
          className={styles.AboutUsShortDiscription}
          mt="20px"
          fontSize={{ xs: "14px", sm: "15px", md: "16px" }}
        >
          Thoughtfully curated hampers for <br />
          every celebration.
        </Typography>
      </Box>

      {/* RIGHT SECTION – CAROUSEL */}
      <Box
        width="100vw"
        mt="24px"
        sx={{
          position: "relative",
          left: "50%",
          right: "50%",
          marginLeft: "-50vw",
          marginRight: "-50vw",
        }}
      >
        <ManualImageCarousel
          cards={images}
          paddingLeft="calc((100vw - 940px) / 2)"
          paddingRight="calc((100vw - 940px) / 2)"
        />
      </Box>
    </Box>
  );
};

export default Gifting;
